import * as React from "react";
import { memo } from "react";
import get from "lodash/get";
import { useRecordContext } from "ra-core";
import Void from "../../../components/Void";
import Adjust from "../../../components/Adjust";

const VoidField = memo((props) => {
  const record = useRecordContext(props);
  const value = get(record, "status");
  const adjust = get(record, "last_adjust_amount.reward");
  if (value !== "Void" && !adjust) return null;
  return <>{value === "Void" ? <Void /> : adjust ? <Adjust /> : null}</>;
});

export default VoidField;
